import BaseEventModel from '../events/base-event-model';
import { IEventSender } from './event-sender';

// A no-operation event sender that does nothing when send is called.
export class NoOpEventSender implements IEventSender {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public send(event: BaseEventModel): Promise<void> {
    return Promise.resolve();
  }
}
